import { React } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { stylemaster } from "../styleConst";
import { useDispatch} from "react-redux";
import AddLocationSharpIcon from '@mui/icons-material/AddLocationSharp';
import { setMapCentreCord, setDrawFeature} from "../../../redux/actions/mapaction";
import { v4 as uuidv4 } from 'uuid';
import { closeUserFolio  } from "../../../redux/actions/controlbuttonaction";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { bgColors } from "../../utils/bgColor";
import { sidebarwith } from "../const";
function UserPolyPage({ onScroll, listInnerRef, userpoly }) {
  const dispatch = useDispatch()

  const handleFolioItemClick = (e,item) => {
    e.preventDefault();
    let polygon = {
        id: uuidv4(),
        coords:JSON.parse(item.geometry).coordinates
    }
    let centroid = {longitude: JSON.parse(item.centroid).coordinates[0],
      latitude: JSON.parse(item.centroid).coordinates[1]
    }
  
    dispatch(setMapCentreCord(centroid))
    dispatch(setDrawFeature(polygon))  
    dispatch(dispatch(closeUserFolio))  
}

// const handleAnalyzeParcel= (e,item) => {
//   e.preventDefault();
//   let polygon = {
//       id: uuidv4(),
//       coords:JSON.parse(item.geometry).coordinates
//   }
//   let centroid = {longitude: JSON.parse(item.centroid).coordinates[0],
//     latitude: JSON.parse(item.centroid).coordinates[1]
//   }
//   dispatch(setMapCentreCord(centroid))
//   dispatch(setDrawFeature(polygon))  
//   dispatch(dispatch(openAnalysisWindow))  
// }


  return (
      <Box
        onScroll={onScroll}
        ref={listInnerRef}
        style={{ height: "100vh", 
        width:'100%',
        overflowY: "auto",
        // padding:'0.1rem',
       }}
      >
        {userpoly.map((item, index) => {
          return (
          <Card
            key={index}
            sx={{
              minWidth:sidebarwith,
              height:100,
              width:'100%',
              background:bgColors.default_backgroun_grey,
              }}
              onClick={((e) => handleFolioItemClick(e, item))}
            > 

            <CardContent>
              <Grid container sx = {{display:'flext-start'}}>
              <AddLocationSharpIcon
                  style= {{height:'20px', width:'20px'}}
                />
              <Typography style ={stylemaster.Typography_body} key = {`loc_long_${index}`}> Long: {JSON.parse(item.centroid).coordinates[0]} </Typography>
              <Typography style ={stylemaster.Typography_body} key = {`loc_lat_${index}`}> Lat: {JSON.parse(item.centroid).coordinates[1]}  </Typography>
              </Grid>
              <Typography style ={stylemaster.Typography_body} key = {`name_${index}`}> Parcel name: {item.name}  </Typography>
              <Typography style ={stylemaster.Typography_body} key = {`state_nam_${index}`}> location: {item.state_name} ,{item.district_name},{item.subdistrict_name}, ,{item.village_name} </Typography>
              <Typography style ={stylemaster.Typography_body} key = {`sno_nam_${index}`}> survey_nos: {item.survey_no} </Typography>
              <Typography style ={stylemaster.Typography_body} key = {`area_${index}`}> Area (acre): {item.area_acre} </Typography>
              
            </CardContent>  
            </Card>
          );
        })}
      </Box>
  );
}

export default UserPolyPage;
